import { ReactNode, forwardRef } from 'react';

import { Text } from '@backstage/ui';

import { useDialogContext } from './context';

export interface TitleBuiProps {
  children: ReactNode;
  className?: string;
}

export const TitleBui = forwardRef<HTMLHeadingElement, TitleBuiProps>(
  ({ children, className }, ref) => {
    const { id } = useDialogContext();

    return (
      <Text
        id={`${id}-title`}
        variant="title-medium"
        as="h2"
        ref={ref}
        className={className}
      >
        {children}
      </Text>
    );
  },
);

TitleBui.displayName = 'DialogCompositeBui.Title';

export default TitleBui;
